import { AvisInputMask } from "./AvisInputMask";
import { IDotsInput } from "dots-ui/dotsInput";

interface IAvisInputMaskTimingProps<T> extends IDotsInput<T> {
  name?: string;
  value?: string;
  title?: string;
  onChange?: (e: any) => void;
}

export function AvisInputMaskTiming<T = object>(
  props: Readonly<IAvisInputMaskTimingProps<T>>,
) {
  return (
    <AvisInputMask<T>
      slotChar="hh.mm.ss"
      mask="99:99:99"
      title={props.title}
      {...props}
    />
  );
}
